<template style="overflow:hidden">
    <div class="page" ref="cmdlist">
      <Header></Header>
      <!-- 板块切换 -->
      <section >
        <router-view></router-view>
      </section>
      <!-- 页脚 -->
      <Footer></Footer>
    </div>
</template>

<script>
  import { httpAction, getAction } from '@/api/manage'
  import Footer from "./Footer"
  import Header from "./Header"
  export default {
    name: "About",
    components:{ Footer,Header },
    data(){
      return{
        user_type: false,
        active_index:"",
        propId:"",
        searchValue:"",
        pageHeight:window.innerHeight
      }
    },
    mounted(){
      var that = this;
      window.addEventListener("resize", (()=>{that.autoTranslate()}));
    },
    created(){
      this.$nextTick(function(){
        if(sessionStorage.getItem("active_index")){
          this.active_index = sessionStorage.getItem("active_index");
          this.propId = sessionStorage.getItem("propId")
        }else{
          this.active_index = 0;
          this.propId = "";
        }
      })
    },
    computed:{
      getNavIndex(){
        return parseInt(this.$store.state.navIndex)
      }
    },
    watch: {
      getNavIndex(newVal) {
        this.$refs.cmdlist.scrollTop = 0;
      }
    },
    methods:{
      autoTranslate(){
        this.pageHeight = window.innerHeight;
      },
      // gotoView(index,id,jglx){
      //   this.$refs.cmdlist.scrollTop = 0;
      //   this.active_index = "-1";
      //   this.jglx = null;
      //   setTimeout(() => {
      //     if(!id){
      //       sessionStorage.setItem("propId","")
      //       this.propId = "";
      //       sessionStorage.setItem("active_index",index);
      //       this.active_index = index;
      //       this.jglx = jglx;
      //     }else{
      //       sessionStorage.setItem("propId",id);
      //       this.propId = id;
      //       sessionStorage.setItem("active_index",index);
      //       this.active_index = index;
      //       this.jglx = jglx;
      //     }
      //   }, 100);
      // }
    }
  }
</script>

<style scoped lang="less">

body{
  overflow-x: auto !important;
}
.page{
  width: 100%;
  overflow: hidden;
  overflow-y: auto;
  overflow-x: auto;
}

p,h3{
  font-family: fzqk;
}

section{
  width: 1228.8px;
  padding: 0 18%;
  min-height: 588px;
  margin: 0 auto;
}
</style>
